var render, staticRenderFns
import script from "./CustomAtTextarea.vue?vue&type=script&lang=ts&"
export * from "./CustomAtTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./CustomAtTextarea.vue?vue&type=style&index=0&id=59442bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59442bb6",
  null
  
)

export default component.exports